<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>
    <loading
        :active.sync="loading"
        :can-cancel="false"
        :is-full-page="true"
    ></loading>
    <b-card class="bCard">
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-book fa-fw"></span>
          <span> Montos MSI </span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>Montos_msi</div>
        </b-col>
      </b-row>

      <b-row class="divSubtitulo">
        <b-col class="text-right">
          <b-button
              v-if="$localStorageService.can('M2_msi_crear')"
              pill variant="outline-success"
              size="small"
              @click="agregarMSI()"
              title="Agregar Nuevo MSI"
              v-b-tooltip.hover
          >Agregar nuevo MSI
          </b-button>
        </b-col>
        <br><br>
      </b-row>

      <!--<p>FILTRO</p>
      <b-row>
        <br>
        <b-col class="12">
        Id MSI
          <b-form-input v-model="filtros.idMSI"
                        placeholder="Busqueda por ID"
                        class="3"
          ></b-form-input>
        </b-col>
        <b-col>
          <boton-cancelar class="mb-3 mt-3" @accion="obtenerGarantiaServicio" :variant="'primary'" :loader="loader" :boton-text="'Buscar'" :loading-text="'Buscando..'" ></boton-cancelar>
        </b-col>
      </b-row>
      -->

      <br>
      <b-row>
        <b-col>
          <b-table
              thead-tr-class="columnas"
              :fields="columnas"
              :items="registrosMSI"
              :per-page="registrosPorPagina"
              :current-page="paginaActual"
              class="parrafos"
              responsive
          >
            <template #cell(montoMinimo)="row">
              <span>{{ row.item.montoMinimo | monedaEntero }}</span>
            </template>

            <template #cell(estatus)="row">
              <b-badge v-if="row.item.registroActivo" pill variant="success"> Activo</b-badge>
              <b-badge v-else pill variant="secondary"> Inactivo</b-badge>
            </template>

            <template #cell(accionenes)="row">
              <b-button-group size="sm">
                <b-button v-if="row.item.registroActivo && $localStorageService.can('M2_msi_editar')" variant="warning" @click="modificar(row.item)">
                  <font-awesome-icon icon="pen"/>
                </b-button>
                <b-button v-if="!row.item.registroActivo && $localStorageService.can('M2_msi_activar')" variant="info" @click="activarDesactivar(row.item)">
                  <font-awesome-icon icon="undo"/>
                </b-button>
                <b-button  v-if="row.item.registroActivo && $localStorageService.can('M2_msi_activar')" variant="danger">
                  <font-awesome-icon icon="trash" @click="activarDesactivar(row.item)"/>
                </b-button>
              </b-button-group>
            </template>
          </b-table>

          <b-spinner v-if="loader" small></b-spinner>


          <b-pagination
              v-if="registrosMSI.length > registrosPorPagina "
              align="center"
              v-model="paginaActual"
              :total-rows="registrosMSI.length"
              :per-page="registrosPorPagina"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>


    <!--MODAL AGREGAR NUEVO MSI -->
    <div>
      <b-modal
          v-model="nuevoMSI"
          :title="tituloModal"
          size=""
          class="w-75"
          no-close-on-backdrop
          no-close-on-esc
      >
        <b-container fliud>

          <b-row class="w-100">
            <label>Banco</label>
            <validacion/>

            <v-select
                class="w-100"
                v-model="$v.listaMSI.idBanco.$model"
                label="nombre"
                :options="bancos"
                placeholder="Banco"
                :reduce="(value) => value.idTerminal"
                :class="selectClass('idBanco')"
            >

            </v-select>
            <b-form-invalid-feedback :state="validateState('idBanco')">
              Se debe seleccionar Banco
            </b-form-invalid-feedback>
          </b-row>


          <b-row class="w-100">
            <label>Meses</label>
            <validacion/>
            <v-select
                class="w-100"
                id="meses"
                label="text"
                v-model.number="$v.listaMSI.meses.$model"
                placeholder="Seleccione meses"
                :options="options"
                :reduce="(value) => value.value"
                :class="selectClass('meses')"
            >
            </v-select>
            <b-form-invalid-feedback :state="validateState('meses')">
              Seleccione una opcion
            </b-form-invalid-feedback>
          </b-row>

          <b-row class="w-100">
            <label>Monto Inicial</label>
            <validacion/>
            <b-input-group size="sm" class="w-100 mb-2" lab>
              <b-input-group-prepend is-text>
                <b-icon icon="cash-stack"/>
              </b-input-group-prepend>
              <b-form-input
                  id="montoInicial"
                  name="montoInicial"
                  type="number"
                  min="0"
                  v-model.number="$v.listaMSI.montoMinimo.$model"
                  placeholder="Monto inicial"
                  :state="validateState('montoMinimo')"
              >
              </b-form-input>
            </b-input-group>
            <b-form-invalid-feedback :state="validateState('montoMinimo')">
              Se debe colocar el monto Inicial
            </b-form-invalid-feedback>
          </b-row>

        </b-container>

        <div slot="modal-footer">
          <boton-cancelar variant="primary" boton-text="Guardar" loading-text="Guardando" :loader="loaderAccion"
                          :pill="false" @accion="guardar()"></boton-cancelar>
          <b-button variant="outline-danger" @click="cerrarModal()"
          >Cancelar
          </b-button
          >
        </div>

      </b-modal>
    </div>
  </div>
</template>

<script>
import Header from "../../components/Header";
import {CatalogosService} from "@/apiServices/catalogos/CatalogosService";
//import BotonCancelar from "@/components/BotonCancelar";
import {required, minLength, numeric} from "vuelidate/lib/validators";
import {validationMixin} from "vuelidate";
import {FacilidaPagoService} from "@/apiServices/facilidadPago/FacilidaPagoService";
import BotonCancelar from "@/components/BotonCancelar";
//import miniToastr from "mini-toastr";

export default {
  name: "PagoMSI",
  components: {
    BotonCancelar,
    //BotonCancelar,
    Header
  },

  mixins: [validationMixin],
  data() {

    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      loading: false,
      facilidaServicio: new FacilidaPagoService(),
      catalogoServicio: new CatalogosService(),

      tituloModal: "",
      nuevoMSI: false,
      idNuevoMSI: null,
      show: false,
      columnas: [
        {key: "idFacilidaPago", label: "Id", sortable: true},
        {key: "banco", label: "Nombre del Banco", sortable: true},
        {key: "meses", label: "MSI", sortable: true},
        {key: "montoMinimo", label: "Monto Minimo", sortable: true},
        {key: "estatus", label: "Estatus", sortable: true},
        {key: "accionenes", label: "Acciones", sortable: true}
      ],

      filtros: {
        idMSI: null
      },

      listaMSI: {
        idFacilidaPago: null,
        idBanco: null,
        tipoPago: null,
        meses: null,
        montoMinimo: null,
        registrActivo: null,
      },

      bancos: [],

      registrosMSI: [],
      paginaActual: 1,
      registrosPorPagina: 15,
      loader: false,
      loaderAccion: false,

      options: [
        {value: 1, text: '1 mes'},
        {value: 3, text: '3 meses'},
        {value: 6, text: '6 meses'},
        {value: 9, text: '9 meses'},
        {value: 12, text: '12 meses'},
        {value: 18, text: '18 meses'},
        {value: 24, text: '24 meses'},
        {value: 36, text: '36 meses'}
      ]
    }
  },
  validations: {
    listaMSI: {
      idBanco: {
        required
      },
      meses: {
        required
      },
      montoMinimo: {
        required, numeric,
        minLength: minLength(1),
      }
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.obtenerBancos();
    this.obtenerRegistros();
  },

  methods: {
    validateState(name) {
      const {$dirty, $error} = this.$v.listaMSI[name];
      return $dirty ? !$error : null;
    },
    selectClass(attribute) {
      let state = this.validateState(attribute)
      if (state) {
        return 'border rounded-lg border-success'
      } else if (state === false) {
        return 'border rounded-lg border-danger'
      } else {
        return ''
      }
    },
    agregarMSI() {
      this.listaMSI = {
        idFacilidaPago: null,
        idBanco: null,
        tipoPago: null,
        meses: null,
        montoMinimo: null,
        registrActivo: null,
      }
      this.nuevoMSI = true
      this.tituloModal = "Agregar Nuevo Monto MSI"
    },

    guardar() {
      this.$v.listaMSI.$touch();
      if (this.$v.listaMSI.$anyError) {
        return;
      }
      if (!this.$v.listaMSI.$invalid) {
        this.loaderAccion = true
        this.facilidaServicio.guardar(this.listaMSI).then(
            () => {
              this.obtenerRegistros()
              this.nuevoMSI = false;
              this.$swal({
                icon: "success",
                text: "Cobro realizado exitosamente",
                confirmButtonText: "OK",
                confirmButtonColor: "#0e6ba9",
              });
            }
        ).finally(() => {
          this.loaderAccion = false;
        })
      }


    },
    obtenerRegistros() {
      this.loader =true
      this.facilidaServicio.obtenerRegistros().then(
          resp => {
            this.registrosMSI = resp.data
          }
      ).finally(() => {
        this.loader = false
      })

    },
    obtenerBancos() {
      this.$http.get(this.$api + "catalogos/listaBancos")
          .then((respuesta) => {
            if (respuesta.data.data) {
              this.bancos = respuesta.data.data;
            }
          });
    },
    cerrarModal() {
      this.nuevoMSI = false
    },
    modificar(item) {
      this.listaMSI = JSON.parse(JSON.stringify(item))
      this.nuevoMSI = true;
    },
    activarDesactivar(item) {

      const text = item.registroActivo ? '¿Está seguro de eliminar el registro ?' : '¿Está seguro de activar el registro ?'
      const textConfirmacion = item.registroActivo ? 'inactivado' : 'activado'

      this.$swal({
        icon: "warning",
        text: text,
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if (aceptar.value) {
          item.registroActivo = !item.registroActivo

          const parametros = {id: item.idFacilidaPago}
          this.facilidaServicio.activarDesactivar(parametros).then(
              () => {
                this.$swal({
                  icon: "success",
                  text: 'Registro ' + textConfirmacion + ' correctamente',
                  confirmButtonText: "OK",
                  confirmButtonColor: "#0e6ba9",
                });
              }
          ).catch(
              error => {
                console.error(error)
                item.registroActivo = !item.registroActivo
                this.$swal({
                  icon: "error",
                  text: 'Ocurrio un error al actiuualizar el registro',
                  confirmButtonText: "OK",
                  confirmButtonColor: "#0e6ba9",
                });
              }
          )

        }
      });
    }

    /*obtenerMeses() {
      if (this.pago.formaPago != null && this.pago.formaPago.idFormaPago === 7 && this.pago.monto != null && this.pago.monto >= 9000 && this.pago.financiera === 1) {
        this.$http.get(this.$api + "forma/list/meses?monto=" + this.pago.monto).then((res) => {
          if (res.data.data) {
            const msiFin = res.data.data

            if (this.pago.msi != null && !msiFin.includes(this.pago.msi)) {
              this.pago.msi = null
            }

            this.msis = this.msis.filter(value => msiFin.includes(value.value));
          }
        });
      } else {
        this.msis = this.$global.msi()
      }
    },*/
  }
}

</script>

<style scoped>
.bCard {
  margin: 2% 4% 2% 4%;
  padding: 0.5% 1% 0.5% 1%;
  border-radius: 20px;
}

.divSubtitulo {
  width: 100%;
  margin-top: 2%;
  border-bottom: 5px solid #8ec6e9;
}

.textSubtitulo {
  color: #093974;
  font-weight: 600;
  font-size: 22px;
  text-align: left;
}

</style>